import React from 'react';
import styled from 'styled-components'

const ImageContainer = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: center;
`;

const ImageStyled = styled.img`
    display: inherit;
    object-fit: cover;
    height: 250px;
    width: 100%;
`;


const ImageSpeaker = ({ image }) => {
    return (
        <ImageContainer>
            <ImageStyled src={image} alt="" />
        </ImageContainer>
    )
}

export default ImageSpeaker;